export default "__VITE_ASSET__BSaauiTa__"